import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const isDev = process.env.REACT_APP_ENV_MODE === 'dev';

interface StoreState {
  isOpen: boolean;
  titleText: string;
  bodyText: string;
  hasCloseButton: boolean;
}

interface StoreActions {
  setOpen: () => void;
  setClose: () => void;
  setTitleText: (titleText: string) => void;
  setBodyText: (bodyText: string) => void;
  setHasCloseButton: (hasCloseButton: boolean) => void;
  clearState: () => void;
}

const initialState: StoreState = {
  isOpen: false,
  titleText: '',
  bodyText: '',
  hasCloseButton: true,
};

const useDialogStore = create<StoreState & StoreActions>()(
  devtools(
    set => ({
      ...initialState,
      setOpen: () => set({ isOpen: true }),
      setClose: () => set({ isOpen: false }),
      setTitleText: (titleText: string) => set({ titleText }),
      setBodyText: (bodyText: string) => set({ bodyText }),
      setHasCloseButton: (hasCloseButton: boolean) => set({ hasCloseButton }),
      clearState: () => set({ ...initialState }),
    }),
    { name: 'DialogStore', enabled: isDev },
  ),
);

export default useDialogStore;
